import { PayRate } from "../../app/data/drivers/models";
import { DriverPayInfo } from "./buildTripSettlementData";

type DriverRecord = DriverPayInfo & {
  payRates?: PayRate[];
};

export const parseRateAmount = (value?: number | string | null): number | undefined => {
  if (value == null || value === "") return undefined;
  if (typeof value === "number") return Number.isFinite(value) ? value : undefined;

  const cleaned = String(value).replace(/[^0-9.-]/g, "");
  if (!cleaned) return undefined;

  const parsed = Number(cleaned);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const extractDriverPayInfo = (driver?: DriverRecord | null): DriverPayInfo | undefined => {
  if (!driver) return undefined;

  return {
    payRates: driver.payRates,
    hourlyRate: driver.hourlyRate,
    perMileRate: driver.perMileRate,
  };
};
